var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.917 38.3333C33.0142 38.3333 32.2469 38.0173 31.6149 37.3854C30.983 36.7534 30.667 35.9861 30.667 35.0833C30.667 34.975 30.6941 34.7222 30.7482 34.325L23.1378 29.8833C22.8489 30.1541 22.5149 30.3665 22.1357 30.5203C21.7566 30.6741 21.3503 30.7507 20.917 30.75C20.0142 30.75 19.2469 30.434 18.6149 29.802C17.983 29.1701 17.667 28.4027 17.667 27.5C17.667 26.5972 17.983 25.8298 18.6149 25.1979C19.2469 24.5659 20.0142 24.25 20.917 24.25C21.3503 24.25 21.7566 24.3269 22.1357 24.4807C22.5149 24.6345 22.8489 24.8465 23.1378 25.1166L30.7482 20.675C30.7121 20.5486 30.6897 20.4269 30.6811 20.3099C30.6724 20.1929 30.6677 20.0618 30.667 19.9166C30.667 19.0138 30.983 18.2465 31.6149 17.6145C32.2469 16.9826 33.0142 16.6666 33.917 16.6666C34.8198 16.6666 35.5871 16.9826 36.2191 17.6145C36.851 18.2465 37.167 19.0138 37.167 19.9166C37.167 20.8194 36.851 21.5868 36.2191 22.2187C35.5871 22.8507 34.8198 23.1666 33.917 23.1666C33.4837 23.1666 33.0774 23.0897 32.6982 22.9359C32.3191 22.782 31.985 22.5701 31.6962 22.3L24.0857 26.7416C24.1219 26.868 24.1446 26.9901 24.154 27.1078C24.1634 27.2255 24.1677 27.3562 24.167 27.5C24.1663 27.6437 24.1619 27.7748 24.154 27.8932C24.146 28.0117 24.1233 28.1333 24.0857 28.2583L31.6962 32.7C31.985 32.4291 32.3191 32.2172 32.6982 32.064C33.0774 31.9109 33.4837 31.834 33.917 31.8333C34.8198 31.8333 35.5871 32.1493 36.2191 32.7812C36.851 33.4132 37.167 34.1805 37.167 35.0833C37.167 35.9861 36.851 36.7534 36.2191 37.3854C35.5871 38.0173 34.8198 38.3333 33.917 38.3333Z",
    fill: "#191918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareModalIcon);
export default __webpack_public_path__ + "static/media/share-modal-icon.92b3cf415ea18f96dbd42940324e76e7.svg";
export { ForwardRef as ReactComponent };